import ArrowStyleLeft from "../../../../assets/icons/ArrowStyle/ArrowStyleLeft";
import ArrowStyleRight from "../../../../assets/icons/ArrowStyle/ArrowStyleRight";
import CartEmptyIcon from "../../../../assets/icons/CartEmpty";
import useWindowSize from "../../../../hooks/useWindowSize";
import { addCartItem } from "../../../../services/cartShoppingService";
import { getUser } from "../../../../services/userService";
import { refreshAccessToken } from "../../../../store/slice/authSlice";
import { ProductType } from "../../../../store/slice/productsSlice";
import { AppDispatch, RootState } from "../../../../store/store";
import { getPrice } from "../../../../utils/getPrice";
import "./ProductCarousel.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ProductCarousel: React.FC<{
  products: ProductType[];
  type?: "primary" | "secondary";
  colorButton?: string;
  displayRef?: boolean;
}> = ({ products, type = "primary", colorButton, displayRef = true }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const dispatch = useDispatch<AppDispatch>();
  const { width } = useWindowSize();
  const navigate = useNavigate();

  const { user } = useSelector((state: RootState) => state.user);
  const { access_token } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (access_token && !user?.id) {
      dispatch(getUser(access_token));
    }
  }, [user, access_token, dispatch]);

  useEffect(() => {
    dispatch(refreshAccessToken());
  }, [dispatch]);

  const getProductNumberList = (width: number) => {
    if (width > 1350) {
      return 5;
    } else if (width >= 1200 && width <= 1350) {
      return 4;
    } else if (width >= 960 && width <= 1200) {
      return 3;
    } else if (width < 960 && width > 550) {
      return 2;
    } else {
      return 1;
    }
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0
        ? products.length - getProductNumberList(width)
        : prevIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === products.length - getProductNumberList(width)
        ? 0
        : prevIndex + 1
    );
  };

  return (
    <div className="carousel-product">
      <div
        className="carousel-inner"
        style={{
          transform: `translateX(-${
            currentIndex * (100 / getProductNumberList(width))
          }%)`,
        }}
      >
        {products.map((product, idx) => (
          <div
            key={idx}
            className="carousel-item"
            style={{
              flex: `0 0 calc(100% / ${getProductNumberList(width)})`,
              width: `calc(100 / ${getProductNumberList(width)})`,
            }}
          >
            <div
              style={
                type === "primary"
                  ? {
                      backgroundColor: "#c4dfe7",
                    }
                  : {
                      backgroundColor: "white",
                      border: "1px solid #447f85",
                    }
              }
            >
              <div
                style={
                  type === "primary"
                    ? {
                        border: "1px solid #447f85",
                        padding: "16px",
                        width: "calc(100% - 32px - 2rem)",
                      }
                    : { width: "calc(100% - 2rem)" }
                }
              >
                <div
                  onClick={() =>
                    navigate(
                      `/category-product/${product.Category?.code}/${product.SubCategory?.code}/${product.Code}`
                    )
                  }
                >
                  <img src={product.ImageUrl} alt={product.Designation} />
                </div>
              </div>
              <div
                className="product-info"
                style={{ height: type === "primary" ? "160px" : "100px" }}
              >
                <div>
                  <div className="designation">{`${product.Designation?.slice(
                    0,
                    40
                  )}${
                    product.Designation && product.Designation?.length > 40
                      ? "..."
                      : ""
                  }
        `}</div>
                  {displayRef && (
                    <div className="reference">Réf. {product.Reference}</div>
                  )}
                </div>
                <div className="button-product">
                  {type === "primary" && (
                    <div className="price-primary">
                      {getPrice(product.PrixHT, user?.discountRate)
                        .toString()
                        .replace(".", ",")}
                      € HT
                    </div>
                  )}
                  <div
                    className="buttons-product"
                    style={
                      type === "primary"
                        ? {
                            justifyContent: "flex-end",
                          }
                        : {
                            justifyContent: "space-between",
                            alignItems: "end",
                          }
                    }
                  >
                    {type === "primary" ? (
                      <button>Voir le produit</button>
                    ) : (
                      <div>
                        {getPrice(product.PrixHT, user?.discountRate)
                          .toString()
                          .replace(".", ",")}
                        € HT
                      </div>
                    )}
                    <button
                      style={{ backgroundColor: colorButton ?? "#35a0a6" }}
                      onClick={() =>
                        product.Code &&
                        dispatch(
                          addCartItem({
                            productCode: product.Code,
                            quantity: 1,
                          })
                        )
                      }
                    >
                      <CartEmptyIcon />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="carousel-button">
        <div>
          <button className="prev" onClick={prevSlide}>
            <ArrowStyleLeft />
          </button>
        </div>
        <div>
          <button className="next" onClick={nextSlide}>
            <ArrowStyleRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCarousel;
